import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownSection,
  DropdownItem,
} from "@heroui/dropdown";
import { LangContext } from "../App";
import { useContext } from "react";
import useTxt from "../useTxt";

export function LangDropDown2(props) {
  let tr = useTxt();
  return <>{tr(`Cambia lingua (attuale=0)!`)}</>;
  //   return strings[`Cambia lingua (attuale=0)!`];
}

export function LangDropDown(props) {
  const [lang, setLang] = useContext(LangContext);
  const basePath = window.location.pathname.includes("/minecraft.dev") ? "/minecraft.dev" : "";

  return (
    <Dropdown shouldBlockScroll={false} >
      <DropdownTrigger>
        <button className="lang-dropdown-btn">
          <img src={`${basePath}/img/${lang || "de"}.png`} />
        </button>
      </DropdownTrigger>
      <DropdownMenu
      className="lang-dropdown"
        aria-label="Languages"
        selectionMode="single"
        onSelectionChange={(keys) => {
          let k = [...keys][0];
          console.log(keys, k);
          // props.onChange?.(e);
          setLang(k);
        }}
      >
        <DropdownItem key="de">
          <img src={`${basePath}/img/de.png`} />          
        </DropdownItem>
        <DropdownItem key="fr">
          <img src={`${basePath}/img/fr.png`} />
        </DropdownItem>
        <DropdownItem key="it">
          <img src={`${basePath}/img/it.png`} />
          
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}

export function Header() {
  const basePath = window.location.pathname.includes("/minecraft.dev") ? "/minecraft.dev" : "";

  return (
    <header>
      <div className="container_logo">
        <div className="logo">
          <img src={`${basePath}/img/Logo-M-minecraft.png`} />
        </div>
        <LangDropDown />
      </div>
    </header>
  );
}